import type { PropsWithChildren } from 'react';

import type { BoxProps } from '@mantine/core';
import { Box, useMantineTheme } from '@mantine/core';

interface GradientBorderProps extends PropsWithChildren {
  gradient: string;
  borderWidth?: number;
  borderRadius?: number | string;
  wrapperProps?: BoxProps;
  contentProps?: BoxProps;
}

export function GradientBorder({
  children,
  gradient,
  borderWidth = 1,
  borderRadius = 0,
  wrapperProps,
  contentProps,
}: GradientBorderProps) {
  const theme = useMantineTheme();
  const { sx: wrapperSx = {}, ...restWrapperProps } = wrapperProps ?? {};
  const { sx: contentSx = {}, ...restContentProps } = contentProps ?? {};

  function getSx(sx: BoxProps['sx']) {
    if (!sx) {
      return [];
    }

    if (Array.isArray(sx)) {
      return sx;
    }

    return [sx];
  }

  return (
    <Box
      sx={[
        {
          background: gradient,
          padding: borderWidth,
          borderRadius,
        },
        ...getSx(wrapperSx),
      ]}
      {...restWrapperProps}
    >
      <Box
        sx={[
          {
            background: theme.white,
            borderRadius,
          },
          ...getSx(contentSx),
        ]}
        {...restContentProps}
      >
        {children}
      </Box>
    </Box>
  );
}
